import { type Localization } from './Interface'

export const localizationFr: Localization = {
  country: {
    BE: {
      text: 'Belgique',
    },
    BG: {
      text: 'Bulgarie',
    },
    CZ: {
      text: 'République tchèque',
    },
    DK: {
      text: 'Danemark',
    },
    DE: {
      text: 'Allemagne',
    },
    EE: {
      text: 'Estonie',
    },
    IE: {
      text: ' Irlande',
    },
    EL: {
      text: 'Grèce',
    },
    ES: {
      text: 'Espagne',
    },
    FR: {
      text: 'France',
    },
    HR: {
      text: 'Croatie',
    },
    IT: {
      text: 'Italie',
    },
    CY: {
      text: 'Chypre',
    },
    LV: {
      text: 'Lettonie ',
    },
    LT: {
      text: 'Lituanie',
    },
    LU: {
      text: 'Luxembourg',
    },
    HU: {
      text: 'Hongrie',
    },
    MT: {
      text: 'Malte',
    },
    NL: {
      text: 'Pays-Bas',
    },
    AT: {
      text: 'Autriche',
    },
    PL: {
      text: 'Pologne',
    },
    PT: {
      text: 'Portugal',
    },
    RO: {
      text: 'Roumanie',
    },
    SI: {
      text: 'Slovénie',
    },
    SK: {
      text: 'Slovaquie',
    },
    FI: {
      text: 'Finlande',
    },
    SE: {
      text: 'Suède',
    },
    IS: {
      text: 'Islande',
    },
    LI: {
      text: 'Liechtenstein',
    },
    NO: {
      text: 'Norvège',
    },
    CH: {
      text: 'Suisse',
    },
    UK: {
      text: ' Royaume-Uni',
    },
    US: {
      text: 'États-Unis',
    },
  },
  'top-menu': {
    logout: {
      text: 'Déconnexion',
    },
    'certificate-list': {
      text: 'Certificats',
    },
    'company-list': {
      text: 'Entreprises',
    },
    'certificate-instance-list': {
      text: 'Organismes de certification',
    },
    'user-list': {
      text: 'Utilisateurs',
    },
    'certificate-type-list': {
      text: 'Types de certificats',
    },
    'logging-list': {
      text: 'Journalisation',
    },
    login: {
      text: 'Connexion',
    },
  },
  certificate: {
    'add-company': {
      text: 'Ajouter un certificat',
    },
    'filter-company-postcode-label': {
      text: 'Code postal',
    },
    'filter-company-postcode-helper': {
      text: "Entrez (une partie du) le code postal d'une entreprise liée",
    },
    'filter-company-input-label': {
      text: 'Entreprise ',
    },
    'filter-company-input-helper': {
      text: "Entrez (une partie du) nom de l'entreprise",
    },
    'filter-scope-input-label': {
      text: 'Portée',
    },
    'filter-scope-input-helper': {
      text: 'Entrez (une partie de) la portée',
    },
    certificateNumber: {
      text: 'Numéro de certificat',
    },
    companyBranches: {
      text: 'Entreprise(s)',
    },
    certificateInstanceVatNumber: {
      text: 'Autorité de certification',
    },
    certificateInstanceName: { text: 'Autorité de certification' },
    companyNames: { text: 'Entreprise(s)' },
    calculatedStatus: { text: 'Statut' },
    companyPostcodes: { text: "Codes postaux de l'entreprise" },
    status: {
      text: 'Statut',
    },
    type: {
      text: 'Type',
    },
    edit: {
      text: 'Modifier le certificat',
    },
    delete: { text: 'Supprimer le certificat' },
    naceCodes: {
      text: 'Codes NACE',
    },
    scope: {
      text: 'Scope',
    },
    certificateInstances: {
      text: 'Autorité de certification',
    },
    issueDate: {
      text: 'Délivré le',
    },
    validFrom: {
      text: 'Valable à partir de',
    },
    validUntil: {
      text: "Valable jusqu'à",
    },
    'scope-max-length-helper': {
      text: '{remainingLength}/{maxLength} caractères restants',
      parameters: ['remainingLength', 'maxLength'],
    },
    isGroupCertificate: {
      text: 'Est multi-établissement',
    },
    addCompanyBranch: {
      text: 'Sélectionnez la société ou saisissez le numéro de TVA',
    },
    'add-companyBranch': {
      text: 'Sélectionnez une entreprise existante',
    },
    'create-new-company': {
      text: 'Ou créer une nouvelle entreprise',
    },
    Valid: {
      text: 'Valide',
    },
    Prolonged: {
      text: 'Prolongé',
    },
    Suspended: {
      text: 'Suspendu',
    },
    Withdrawn: {
      text: 'Retiré',
    },
    extendedUntil: {
      text: "Prolongé jusqu'à",
    },
    'safe-add-button': {
      text: 'Ajouter un certificat',
    },
    'type-missing': {
      text: 'Sélectionnez un type valide',
    },
    'certificateNumber-missing': {
      text: 'Entrez un numéro de certificat valide',
    },
    'naceCodes-missing': {
      text: 'Entrez au moins un code NACE valide',
    },
    'scope-missing': {
      text: "Entrez un champ d'application valide",
    },
    'companyBranches-missing': {
      text: 'Choisissez au moins une entreprise et une succursale',
    },
    'certificateInstanceVatNumber-missing': {
      text: 'Choisissez une autorité de certification',
    },
    'extendedUntil-missing': {
      text: 'Veuillez saisir une date valide',
    },
    'filter-company-postcodes-input-label': {
      text: 'Codes postaux',
    },
    'filter-company-postcodes-input-helper': {
      text: 'Saisissez les codes postaux séparés par des virgules pour les entreprises',
    },
    'filter-status-input-label': { text: 'Statut' },
    'filter-status-input-helper': {
      text: 'Choisissez un statut',
    },
    'filter-certificate-type-input-label': { text: 'Type de certificat' },
    'filter-certificate-type-input-helper': {
      text: 'Choisissez un type de certificat',
    },
    'any-certificate-type': { text: 'Tous les types de certificats' },
    'any-certificate-instance': {
      text: 'Toutes les autorités de certification',
    },
    'filter-certificate-instance-input-label': {
      text: 'Organisme de certification',
    },
    'filter-certificate-instance-input-helper': {
      text: 'Choisissez une autorité de certification',
    },
    'filter-certificate-number-input-label': {
      text: 'Numéro de certificat',
    },
    'filter-certificate-number-input-helper': {
      text: 'Entrez (une partie du) numéro de certificat',
    },
  },
  'logging-list': {
    'filter-email-input-label': {
      text: 'Email',
    },
    'filter-email-input-helper': {
      text: "Entrez (une partie de) le adresse e-mail de l'utilisateur",
    },
    'filter-action-input-label': {
      text: 'Action',
    },
    'filter-action-input-helper': {
      text: "Entrer (une partie de) l'action",
    },
    changeDate: {
      text: 'Date',
    },
    userEmail: {
      text: 'Email',
    },
    action: {
      text: 'Action',
    },
    details: {
      text: 'Détails',
    },
  },
  'certificate-add': {
    type: {
      text: 'Type',
    },
    certificateNumber: {
      text: 'Numéro de certificat',
    },
    naceCodes: {
      text: 'Codes NACE',
    },
    scope: {
      text: 'Scope',
    },
    'scope-max-length-helper': {
      text: '{remainingLength}/{maxLength} caractères restants',
      parameters: ['remainingLength', 'maxLength'],
    },
    isGroupCertificate: {
      text: 'Est multi-établissement',
    },
    companyBranches: {
      text: 'Entreprises et succursales',
    },
    addCompanyBranch: {
      text: 'Sélectionner une entreprise ou saisir un numéro de TVA',
    },
    'add-companyBranch': {
      text: 'Sélectionnez une entreprise existante',
    },
    'create-new-company': {
      text: 'Ou créer une nouvelle entreprise',
    },
    status: {
      text: 'Status',
    },
    Valid: {
      text: 'Valide',
    },
    Prolonged: {
      text: 'Prolongé',
    },
    Suspended: {
      text: 'Suspendu',
    },
    Withdrawn: {
      text: 'Retiré',
    },
    certificateInstances: {
      text: 'Instance de certification',
    },
    issueDate: {
      text: 'Émis le ',
    },
    validFrom: {
      text: 'Valide à partir de',
    },
    validUntil: {
      text: "Valide jusqu'à",
    },
    extendedUntil: {
      text: "Prolongé jusqu'à",
    },
    'safe-edit-button': {
      text: 'Enregistre',
    },
    'certificate-save-in-progress': {
      text: "Le certificat est en cours d'enregistrement.",
    },
    'companyBranches-not-selected': {
      text: 'Choisissez au moins un emplacement',
    },
  },
  components: {
    'select-from-list': {
      text: 'Sélectionner dans la liste',
    },
    'select-no-options-match-search': {
      text: 'Aucune option ne correspond au terme de recherche',
    },
    'data-being-loaded': { text: 'Les données sont en cours de chargement.' },
    loading: { text: '...' },
  },
  company: {
    'add-company': {
      text: 'Ajouter une société',
    },
    'vat-number': {
      text: 'Company number',
    },
    'invalid-vat-number': {
      text: ' Saisissez un numéro de TVA valide commençant par le code du pays',
    },
    name: {
      text: 'Naam',
    },
    'legal-form': {
      text: 'Forme juridique',
    },
    email: {
      text: 'Email',
    },
    website: {
      text: 'Site Web',
    },
    addressLine1: {
      text: 'Rue et numéro de rue',
    },
    postalCode: {
      text: 'Code postal',
    },
    city: {
      text: 'Municipalité',
    },
    country: {
      text: 'Pays',
    },
    naceCode: {
      text: 'Code NACE',
    },
    'accident-counts': {
      text: 'Chiffres des accidents du travail',
    },
    branches: {
      text: 'Emplacements',
    },
    'safe-add-button': {
      text: 'Ajouter une entreprise',
    },
    'filter-vat-number-input-label': {
      text: "Numéro d'entreprise",
    },
    'filter-vat-number-input-helper': {
      text: "Entrez (une partie du) numéro d'entreprise",
    },
    'filter-company-input-label': {
      text: 'Entreprise',
    },
    'filter-company-input-helper': {
      text: "Entrez (une partie du) nom de l'entreprise",
    },
    vatNumber: {
      text: "Numéro d'entreprise",
    },
    legalForm: {
      text: ' Forme juridique',
    },
    edit: {
      text: 'Modifier la société',
    },
    delete: { text: "Supprimer l'entreprise" },
    'nace-code': {
      text: 'Code NACE',
    },
    certificates: {
      text: 'Certificats',
    },
    'reload-vat-info': {
      text: "Recharger les informations sur l'entreprise",
    },
    'add-accident-count': {
      text: 'Ajouter une année',
    },
    'safe-edit-button': {
      text: 'Enregistre',
    },
    'vat-info-fetch-in-progress': {
      text: 'Récupération des données pour la société {vatNumber}',
      parameters: ['vatNumber'],
    },
    'remove-accident-count': {
      text: "Supprimer l'année",
    },
    'company-save-in-progress': {
      text: "L'entreprise est en cours de sauvegarde.",
    },
    lastKpbCheck: { text: 'Dernière synchronisation KBO' },
    'change-company-vat': {
      text: "Changer le numéro d'enregistrement de l'entreprise",
    },
    'old-vat-number': {
      text: "Changer le numéro d'entreprise {vatNumber}",
      parameters: ['vatNumber'],
    },
    'change-vat': {
      text: "Changer le numéro d'enregistrement",
    },
    'confirm-company-delete': {
      text: 'Êtes-vous sûr de vouloir supprimer cette entreprise ?',
    },
    'confirm-certificate-delete': {
      text: 'Êtes-vous sûr de vouloir supprimer ce certificat ?',
    },
    'kbo-success': { text: 'Rapéussi' },
    'kbo-failure': { text: 'Echoué' },
  },
  'certificate-instance': {
    'add-certificate-instance': {
      text: 'Ajouter une instance de certificat',
    },
    'filter-name-input-label': {
      text: 'Name',
    },
    'filter-name-input-helper': {
      text: "Entrez (une partie du) nom de l'autorité de certification",
    },
    name: {
      text: 'Nom',
    },
    addressLine1: {
      text: 'Rue et numéro de rue',
    },
    postalCode: {
      text: 'Code postal',
    },
    city: {
      text: 'Municipalité',
    },
    countryCode: {
      text: 'Pays',
    },
    'vat-number': {
      text: "Numéro d'entreprise",
    },
    'invalid-vat-number': {
      text: 'Entrez un numéro de TVA valide commençant par le code du pays',
    },
    email: {
      text: 'E-mail',
    },
    website: {
      text: 'Site Web',
    },
    telephone: {
      text: 'Téléphone',
    },
    country: {
      text: 'Pays',
    },
    coordinators: {
      text: 'Coordinateurs VCA',
    },
    'safe-add-button': {
      text: 'Ajouter une autorité de certification',
    },
    edit: {
      text: "Modifier l'autorité de certification",
    },
    delete: { text: "Supprimer l'autorité de certification" },
    'coordinator-name': {
      text: 'Nom',
    },
    'coordinator-email': {
      text: 'Email',
    },
    'coordinator-telephone': {
      text: 'GSM',
    },
    certificates: {
      text: 'Certificates',
    },
    'reload-vat-info': {
      text: "Recharger les informations sur l'entreprise",
    },
    'remove-coordinator': {
      text: 'Supprimer le coordinateur',
    },
    'add-coordinator': {
      text: 'Ajouter un coordinateur VCA',
    },
    'safe-edit-button': {
      text: 'Enregistre',
    },
    'name-missing': {
      text: 'Entrez un nom valide dans',
    },
    'email-missing': {
      text: 'Entrez une adresse e-mail valide',
    },
    'vat-info-fetch-in-progress': {
      text: 'Les données de la société {vatNumber} sont récupérées',
      parameters: ['vatNumber'],
    },
    'email-invalid': {
      text: "Le format de l'e-mail est incorrect",
    },
    'website-invalid': {
      text: 'Le format du site Web est incorrect ',
    },
    'telephone-required': { text: 'Le téléphone portable est obligatoire' },
    'telephone-invalid': {
      text: 'Le format du téléphone est incorrect',
    },
    'certificate-instance-save-in-progress': {
      text: "L'instance de certificat est en cours d'enregistrement.",
    },
    'confirm-certificate-instance-delete': {
      text: 'Êtes-vous sûr de vouloir supprimer cette autorité de certification ?',
    },
  },
  'user-list': {
    'add-user': {
      text: 'Ajouter un utilisateur',
    },
    'filter-email-input-label': {
      text: 'Email',
    },
    'filter-email-input-helper': {
      text: "Entrez (une partie de) l'adresse e-mail de l'utilisateur",
    },
    email: {
      text: 'Email',
    },
    isAdmin: {
      text: "Est l'administrateur",
    },
    certificateInstanceVatNumber: {
      text: 'Instance de certificat',
    },
  },
  user: {
    email: {
      text: 'Email',
    },
    'is-admin': {
      text: 'Est administrateur',
    },
    'certificate-instance': {
      text: 'Instance de certificat',
    },
    'remove-button': {
      text: "Supprimer l'utilisateur",
    },
    'safe-add-button': {
      text: 'Ajouter un utilisateur ',
    },
    'email-invalid': {
      text: "Le format de l'e-mail est incorrect",
    },
    'user-save-in-progress': {
      text: "L'utilisateur en cours d'enregistrement.",
    },
    'delete-user-prompt': {
      text: 'Êtes-vous sûr de vouloir supprimer définitivement cet utilisateur ?',
    },
    'user-delete-in-progress': {
      text: "L'utilisateur est en cours de suppression.",
    },
  },
  'certificate-type': {
    'add-certificate-type': {
      text: 'Ajouter un type de certificat',
    },
    'filter-name-input-label': {
      text: 'Nom',
    },
    'filter-name-input-helper': {
      text: 'Entrez (une partie de) le nom du type de certificat',
    },
    'filter-is-active-input-label': {
      text: 'Est actif',
    },
    'filter-is-active-input-helper': {
      text: 'Est-il actif ou non',
    },
    yes: {
      text: ' est actif',
    },
    no: {
      text: "n'est pas actif",
    },
    'filter-nace-limitation-input-label': {
      text: 'Limitation NACE',
    },
    'filter-nace-limitation-input-helper': {
      text: ' Saisissez (une partie de) la contrainte NACE',
    },
    name: {
      text: 'Name',
    },
    isActive: {
      text: 'Est actif',
    },
    naceLimitation: {
      text: ' Limité aux codes NACE',
    },
    'safe-add-button': {
      text: 'Ajouter un certificat',
    },
    'name-missing': {
      text: 'Entrez un nom de type de certificat valide',
    },
  },
  'certificate-type-add': {
    name: {
      text: 'Nom',
    },
    isActive: {
      text: 'Est actif',
    },
    naceLimitation: {
      text: 'Limité aux codes NACE ',
    },
    'safe-edit-button': {
      text: 'Enregistre',
    },
    'certificate-type-save-in-progress': {
      text: "Le type de certificat est en cours d'enregistrement.",
    },
  },
  login: {
    'login-email': {
      text: 'E-mail de connexion',
    },
    'login-button': {
      text: 'Connexion',
    },
    'login-email-send': {
      text: "Si l'email est liés à un compte. Nous avons envoyé un lien de connexion à l'adresse e-mail spécifiée. cliquez sur ce lien pour vous connecter.",
    },
  },
  'certificate-statuses': {
    'any-status': { text: 'Tous les statuts' },
    Expired: { text: 'Expiré' },
    Valid: { text: 'Valide' },
    Prolonged: { text: 'Prolongé' },
    Suspended: { text: 'Suspendu' },
    Withdrawn: { text: 'Retiré' },
  },
  general: {
    cancel: { text: 'Annuler' },
    save: { text: 'Sauvegarder' },
  },
}
